var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('svg-icon',{attrs:{"icon-class":"empty"}}),_c('div',{staticClass:"tips"},[_vm._v(_vm._s(_vm.message))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }